export default {
  title: "",
  subtitle: "Payouts",
  path: "transactions_payouts",
  paragraphs: [
    "After registering your customer bank account with us, you will be able to pay them locally using the following endpoint. If you registered only the PIX key, we will be using it, if you registered the Bank details and PIX Key we will prioritize to pay via TED.",
    "The payout transactions are initiated within your foreign currency cash-out account"
  ],
  request: {
    method: "POST",
    endpoint: "/transactions",
    payloads:[
      {
        title: "Example of a conversion",
        content: { 
          "transaction": { 
            "currency": "USD", 
            "exchange_currency": "BRL", 
            "value": "500.00", 
            "from_bank_account_id": "your USD/EUR cash-out internal account id", 
            "to_bank_account_id": "the id of your customer bank account", 
            "subject_id": "your customer id"
          } 
        } 
      }
    ],
    responses: {
      "data": {
          "value": "500.00",
          "to_bank_account": {
              "routing_number": null,
              "pix_info": {
                  "type": "CNPJ",
                  "key": "00.623.904/0001-73"
              },
              "owner_name": "Jose Bonifacio",
              "owner_document_type": "cpf",
              "owner_document_number": "27029324013",
              "nickname": null,
              "intermediary_bank_account_id": null,
              "id": "c41b7cf3-455c-46c1-bb6d-7fd0e1b83799",
              "iban": null,
              "currency": "BRL",
              "branch_number": null,
              "branch_country": "BRA",
              "bank": {
                  "swift": "BCBPIXCNPJ000",
                  "name": "PIX Key - CNPJ",
                  "ispb": null,
                  "id": "aa3bfacc-dd6b-4a68-b37a-7672b43b1c52",
                  "country": "BRA",
                  "code": null
              },
              "account_type": "conta-corrente",
              "account_number": null,
              "aba": null
          },
          "subject_is_receiver": true,
          "subject_id": "01e0725b-b4f5-46b1-811a-a3cbcb314d10",
          "status": "identified",
          "source_name": "John Doe",
          "source_document_type": "cpf",
          "source_document_number": "05069869183",
          "meta": null,
          "inserted_at": "2025-07-10T14:50:16.805590",
          "id": "49330924-1284-418f-9d6f-3a22c13411a3",
          "from_credit_card_id": null,
          "from_bank_account": {
              "routing_number": null,
              "pix_info": null,
              "owner_name": "Biriweb Serviços de Internet Ltd",
              "owner_document_type": null,
              "owner_document_number": "21958642819",
              "nickname": null,
              "internal": true,
              "intermediary_bank_account_id": null,
              "id": "6b1d3acf-42b7-4f5a-8d9b-1da2766e040b",
              "iban": null,
              "flow_type": "cash_out",
              "currency": "USD",
              "branch_number": null,
              "branch_country": null,
              "bank": {
                  "swift": null,
                  "name": "Internal",
                  "ispb": null,
                  "id": "6facab8d-573e-44d0-a4bd-ce2600368263",
                  "country": "BRA",
                  "code": "999"
              },
              "account_type": "conta-corrente",
              "account_number": null,
              "aba": null
          },
          "for_exchange": true,
          "exchange_under_request": false,
          "exchange_currency": "BRL",
          "estimated_value_until_exchange": false,
          "currency": "USD",
          "cleared": true,
          "bank_transaction": {
              "wire_id": null,
              "value": "500.0",
              "spei_reference": null,
              "spei_concepto_de_pago": null,
              "source_type": "TED-PRE",
              "source_name": "John Doe",
              "source_id": "49330924-1284-418f-9d6f-3a22c13411a3",
              "source_document_type": "cpf",
              "source_document_number": "05069869183",
              "source_description": "CREDITO POR TED ANTECIPADO",
              "source_branch": null,
              "source_bank_ispb": null,
              "source_bank": null,
              "source_account": null,
              "movement_date": "2025-07-10",
              "iof_value": null,
              "inserted_at": "2025-07-10T14:50:16.861725",
              "id": "54045ef6-95ae-4fff-96f4-f82f1442548b",
              "exchanged_value": null,
              "exchange_rate_spot": null,
              "exchange_rate": null,
              "exchange_id": null,
              "exchange_currency": "BRL",
              "exchange_approved": false,
              "currency": "USD"
          }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/TransactionPayouts.js